<template>
  <InputVue
    :name="name"
    :label="label"
    :cssClasses="cssClasses"
    :labelAsPlaceholder="labelAsPlaceholder"
    :hasError="hasError">
    <template #input-slot>
      <input 
        ref="input"
        class="form-control" 
        autocomplete="off"
        :name="name" 
        type="text"
        :value="modelValue"
        @input="updateValue"
        :placeholder="labelAsPlaceholder ? label : placeholder " />
    </template>
  </InputVue>
</template>

<script>
import InputVue from './InputCompVue'

export default {
  name: 'TextInputVue',

  props: {
    modelValue: String,
    name: String,
    label: String,
    focus: Boolean,
    cssClasses: String,
    labelAsPlaceholder: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
  },

  data() {
    return {
      hasError: false,
      errors: { hasError: 'error' },
    }
  },

  methods: {
    updateValue(e) {
      this.$emit('update:modelValue', e.target.value)
    },

    toggleError() {
      this.hasError = !this.hasError
    },

    focusInput() {
      this.$refs.input.focus()
    },
  },

  mounted() {
    if (this.focus) this.focusInput()
  },

  created() {
  },

  components: {
    InputVue,
  },
}
</script>

<style>
</style>
